import { Axios } from "../Hooks/useAxiosInstance";
import { useAppContext } from "../Context/AppContext";
import { API_ROUTE } from "../Config";

export const QuizQuestionAPI = () => {
    const { user } = useAppContext();

    const apis = ({ api_token }) => ({
        getQuizQuestions: async (id, params) => await getQuizQuestions(id, params, api_token),
        answerQuizQuestion: async (data) => await answerQuizQuestion(data, api_token),
        submitQuizAnswer: async (data) => await submitQuizAnswer(data, api_token),
        pressBuzzer: async (data) => await pressBuzzer(data, api_token),
    });



    async function getQuizQuestions(id, params, api_token) {
        const url = API_ROUTE.GET_QUIZ_QUESTION(id, params.page, params.limit, params.search);
        const option = {
            headers: {
                Authorization: api_token,
                "Content-Type": "application/json",
            },
        };
        return await Axios.get(url, option);
    }

    async function answerQuizQuestion(data, api_token) {
        const url = API_ROUTE.GIVE_ANSWER;
        const option = {
            headers: {
                Authorization: api_token,
                "Content-Type": "application/json",
            },
        };
        return await Axios.post(url, data, option);
    }

    async function submitQuizAnswer(data, api_token) {
        const url = API_ROUTE.SUBMIT_ANSWER;
        const option = {
            headers: {
                Authorization: api_token,
                "Content-Type": "application/json",
            },
        };
        return await Axios.post(url, data, option);
    }


    async function pressBuzzer(data, api_token) {
        const url = API_ROUTE.PRESS_BUZZER;
        const option = {
            headers: {
                Authorization: api_token,
                "Content-Type": "application/json",
            },
        };
        return await Axios.post(url, data, option);
    }



    return apis({ api_token: user.api_token });
};